import React from 'react';
import { Helmet } from 'react-helmet';

const LandingHelmet: React.FC<{
  title: string;
  metaDescription: string;
  children?: React.ReactNode;
}> = ({ title, children, metaDescription }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta property="og:title" content={title} />
      <meta name="description" content={metaDescription} />
      <meta property="og:description" content={metaDescription} />
      {children}
    </Helmet>
  );
};

export default LandingHelmet;
